module.exports = __webpack_public_path__ + "static/about.0ac8b7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/about.jpg
// module id = 172
// module chunks = 168707334958949